export const getCmdCtrlLabel = (characters: string): string => {
  const isMac = navigator.userAgent.includes('Macintosh');
  const prefix = isMac ? '⌘' : 'CTRL';

  return `${prefix} + ${characters}`;
};
